// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { categoryListStyles } from "@turnerBlueprint/Overrides/Widgets/Category/CategoryList";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { color } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

categoryListStyles.headingContainer = {
    gap: 0,
    offsetCss: css`
        margin-bottom: 6px;
        &&& {
            flex-wrap: nowrap;
            gap: 12px;
        }
    `,
};

categoryListStyles.categoryImageLink = {
    typographyProps: {
        css: css`
            display: flex;
        `,
    },
};

categoryListStyles.innerContainer = {
    gap: 10,
    css: css`
        transition: all 2s linear 1s;
    `,
};

categoryListStyles.categoryName = {
    variant: "h5",
    forwardAs: "p",
    css: css`
        margin: 0;
        color: ${color("text")};
        &:hover {
            color: ${color("common.ui9")};
        }
    `,
};

categoryListStyles.categoryImage = {
    width: "64px",
    height: "64px",
    css: css`
        max-height: 64px;
        object-fit: contain;
    `,
};

categoryListStyles.categoryItem = {
    width: [12, 4, 4, 4, 4],
    css: css`
        padding-bottom: 12px;
    `,
};

categoryListStyles.categoryImageItem = {
    css: css`
        max-width: 64px;
        flex-basis: 64px;
    `,
};

categoryListStyles.categoryNameLinkItem = {
    css: css`
        align-items: center;
        flex-basis: unset;
        max-width: unset;
    `,
};

categoryListStyles.subCategoryNameLink = {
    typographyProps: {
        size: 12,
        lineHeight: "13px",
        weight: fontConfig.weight.bold,
    },
};

categoryListStyles.viewMoreLinkItem = {
    width: 12,
};

categoryListStyles.viewMoreLink = {
    typographyProps: {
        size: 12,
        lineHeight: "14px",
    },
    css: css`
        width: auto;
        ${IconWrapper},
        ${IconWrapper} svg {
            width: 11px;
        }
    `,
};
